import { render } from "./BomValidationResultsElements.vue?vue&type=template&id=31ec96d4&scoped=true"
import script from "./BomValidationResultsElements.vue?vue&type=script&lang=js"
export * from "./BomValidationResultsElements.vue?vue&type=script&lang=js"

import "./BomValidationResultsElements.vue?vue&type=style&index=0&id=31ec96d4&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ec96d4"]])

export default __exports__
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QVirtualScroll});
